import React, { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';

const ProductListItem = React.memo(({ product, type }) => {
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const images = Array.isArray(product?.images) ? product.images : [];

	useEffect(() => {
		if (images.length === 0) {
			setCurrentImageIndex(0);
			return;
		}

		const mainImageIndex = images.findIndex(x => x.isMain);
		setCurrentImageIndex(mainImageIndex !== -1 ? mainImageIndex : 0);
	}, [product]);

	const handleHover = (index) => {
		setCurrentImageIndex(index);
	};

	const handleSwipe = (dir) => {
		if (images.length === 0) return;

		setCurrentImageIndex((prev) => {
			if (dir > 0) {
				return prev === 0 ? images.length - 1 : prev - 1;
			}
			return prev === images.length - 1 ? 0 : prev + 1;
		});
	};

	const swipeHandlers = useSwipeable({
		onSwipedLeft: () => handleSwipe(-1),
		onSwipedRight: () => handleSwipe(1),
		preventDefaultTouchmoveEvent: true,
		trackMouse: true
	});

	const currentImage = images[currentImageIndex];

	return (
		<a href={`/product/${product.id}`} className='product-list-item'>
			{currentImage ? (
				<div className='product-image-block'>
					<img
						loading='lazy'
						alt='product'
						className='product-image'
						src={currentImage.path}
					/>

					{images.length > 1 && (
						<>
							<div {...swipeHandlers} className='product-image-container'>
								{images.map((_, index) => (
									<div
										key={index}
										className='hover-block'
										style={{
											left: `${(index / images.length) * 100}%`,
											width: `${100 / images.length}%`
										}}
										onMouseEnter={() => handleHover(index)}
									/>
								))}
							</div>

							<div className='image-markers'>
								{images.map((_, index) => (
									<div
										key={index}
										className={`marker ${index === currentImageIndex ? 'active' : ''}`}
									/>
								))}
							</div>
						</>
					)}
				</div>
			) : (
				<div className='product-image product-image-not-found'>
					<strong className='text'>Изображение не найдено</strong>
				</div>
			)}

			{product?.name && <h6 className='product-title'>{product.name}</h6>}
		</a>
	);
});

export default ProductListItem;